import { render, staticRenderFns } from "./UserCreateComponent.vue?vue&type=template&id=d99018f0&scoped=true"
import script from "./UserCreateComponent.vue?vue&type=script&lang=js"
export * from "./UserCreateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99018f0",
  null
  
)

export default component.exports